import React from 'react'

export default function PruebasPsicotecnicas() {
  return (
    <div>
      PruebasPsicotecnicas
    </div>
  )
}
